import {
  COMPONENTS_CARD_SHELL,
  COMPONENTS_GRID,
} from './components-page-layout';
import { cn } from '@/lib/utils';

const ComponentsGridSkeleton = () => (
  <div className={COMPONENTS_GRID} aria-hidden="true">
    {Array.from({ length: 6 }).map((_, index) => (
      <div
        key={index}
        className={cn(
          COMPONENTS_CARD_SHELL,
          'animate-pulse rounded-2xl border border-[var(--inv-border)] bg-[var(--inv-surface)]',
        )}
      />
    ))}
  </div>
);

export default ComponentsGridSkeleton;
